<template>
<div v-if="$store.getters['session/isLogged']">
    <div>
        <div class="my-3 text-center">
            <h5 v-if="$store.state.healthyHabits.chart.question" :style="{color: $store.state.healthyHabits.chart.color}" class="my-3">{{$store.state.healthyHabits.chart.question}}</h5>
            <div v-if="$store.state.healthyHabits.chart.measurable" class="my-3"><b-icon-arrow-up-circle-fill :style="{color: $store.state.healthyHabits.chart.color}"></b-icon-arrow-up-circle-fill> {{`${$store.state.healthyHabits.chart.goal} ${$store.state.healthyHabits.chart.measureUnit}`}}</div>
            <div class="my-3"><b-icon-calendar-week></b-icon-calendar-week> {{getGoalIntervalFormatted}}</div>
            <div class="my-3"><b-icon-bell></b-icon-bell> {{getReminderFormatted}}</div>
            <div v-if="$store.state.healthyHabits.chart.notes" class="my-3">{{$store.state.healthyHabits.chart.notes}}</div>
        </div>
        <healthy-habits-statistics-components v-if="$store.state.healthyHabits.chart.showChart"></healthy-habits-statistics-components>
    </div>
</div>
</template>

<script>
import healthyHabitsMixin from '@/mixins/healthyHabits.mixin'
import { DAILY_GOAL, WEEKLY_GOAL, MONTHLY_GOAL } from '@/constants/healthyHabits'
import HealthyHabitsStatisticsComponents from '@/components/views/healthy-habits/HealthyHabitsStatisticsComponents'
import { BIcon } from 'bootstrap-vue'
import { getWeekDaysNames } from '@/helpers/date.helpers'

export default {
   name: 'healthyHabitsStatistics',
   components: {
    BIcon,
    HealthyHabitsStatisticsComponents
   },
   computed: {
    getGoalIntervalFormatted () {
        if (this.$store.state.healthyHabits.chart.measurable) {
            if (this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL) {
                return this.$t('daily')
            } else if (this.$store.state.healthyHabits.chart.goalFrequencyId === WEEKLY_GOAL) {
                return this.$t('weekly')
            } else if (this.$store.state.healthyHabits.chart.goalFrequencyId === MONTHLY_GOAL) {
                return this.$t('monthly')
            }
        } else {
            if (this.$store.state.healthyHabits.chart.goalFrequencyId === DAILY_GOAL) {
                return this.$store.state.healthyHabits.chart.goal === 1 ? `${this.$t('daily')}` : `${this.$t('each')} ${this.$store.state.healthyHabits.chart.goal} ${this.$t('days')}`
            } else if (this.$store.state.healthyHabits.chart.goalFrequencyId === WEEKLY_GOAL) {
                return this.$store.state.healthyHabits.chart.goal === 1 ? `${this.$t('weekly')}` : `${this.$store.state.healthyHabits.chart.goal} ${this.$t('timesToWeek')}`
            } else if (this.$store.state.healthyHabits.chart.goalFrequencyId === MONTHLY_GOAL) {
                return this.$store.state.healthyHabits.chart.goal === 1 ? `${this.$t('monthly')}` : `${this.$store.state.healthyHabits.chart.goal} ${this.$t('timesToMonth')}`
            }
        }
    },
    getReminderFormatted () {
        if (this.$store.state.healthyHabits.chart.reminderDays) {
            let reminderDays = this.$store.state.healthyHabits.chart.reminderDays.split(',').map(day => getWeekDaysNames(false, true).indexOf(day)).map(index => getWeekDaysNames()[index]).join(', ')
            return `${reminderDays} ${this.$t('atHour')} ${this.$store.state.healthyHabits.chart.reminder}`
        } else {
            return this.$t('off')
        }
    }
   },
   created () {
    this.getHealthyHabitsStatistics(this.$route.params.id)
   },
   mixins: [healthyHabitsMixin],
   data () {
    return {
    }
   },
   mounted () {
    window.scrollTo(0, 0)
   },
   methods: {
   }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/healthy-habits/HealthyHabitsStatistics.vue